"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hearingSectionContract = exports.GetSuggestionsForHearingSectionQueryParamsSchema = exports.CreateHearingSectionRequestSchema = exports.UpdateHearingSectionRequestSchema = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@ts-rest/core");
const zod_1 = tslib_1.__importDefault(require("zod"));
const resources_1 = require("./resources");
const c = (0, core_1.initContract)();
exports.UpdateHearingSectionRequestSchema = resources_1.HearingSectionSchema.omit({ hearingId: true }).extend({
    recordingDate: resources_1.LocalDateSchema,
    locationId: zod_1.default.string().uuid(),
});
exports.CreateHearingSectionRequestSchema = exports.UpdateHearingSectionRequestSchema.omit({ id: true });
exports.GetSuggestionsForHearingSectionQueryParamsSchema = zod_1.default.object({
    courtSystemId: zod_1.default.string().uuid(),
    recordingId: zod_1.default.string().uuid(),
    caseReference: zod_1.default
        .string()
        .trim()
        .transform(value => value.toUpperCase()),
});
const path = '/hearing-section';
exports.hearingSectionContract = c.router({
    createHearingSection: {
        method: 'POST',
        path,
        headers: resources_1.UserOrApiAuthHeadersSchema,
        query: zod_1.default.object({
            conflictResolutionToken: zod_1.default.string().optional(),
        }),
        responses: {
            [201]: resources_1.HearingSectionSchema,
            [401]: resources_1.ErrorResponseSchema,
            [403]: resources_1.ErrorResponseSchema,
            [409]: resources_1.HearingSectionConflictsSchema,
        },
        body: exports.CreateHearingSectionRequestSchema,
        summary: 'Create a hearing section',
    },
    getSuggestionsForHearingSection: {
        method: 'GET',
        path: `${path}/suggestion`,
        headers: resources_1.UserAuthHeadersSchema,
        responses: {
            [200]: resources_1.HearingSectionSuggestionsSchema,
            [401]: resources_1.ErrorResponseSchema,
            [403]: resources_1.ErrorResponseSchema,
            [404]: null,
        },
        query: exports.GetSuggestionsForHearingSectionQueryParamsSchema,
        summary: 'Get auto-complete suggestions for a hearing section and given case reference.',
    },
    deleteHearingSection: {
        method: 'DELETE',
        path,
        query: zod_1.default.object({ hearingSectionId: zod_1.default.string().uuid() }),
        headers: resources_1.UserOrApiAuthHeadersSchema,
        responses: {
            [204]: zod_1.default.undefined(),
            [401]: resources_1.ErrorResponseSchema,
            [403]: resources_1.ErrorResponseSchema,
        },
        body: null,
        summary: 'Delete a hearing section',
    },
    updateHearingSection: {
        method: 'PUT',
        path,
        headers: resources_1.UserOrApiAuthHeadersSchema,
        query: zod_1.default.object({
            conflictResolutionToken: zod_1.default.string().optional(),
        }),
        responses: {
            [200]: resources_1.HearingSectionSchema,
            [400]: resources_1.ErrorResponseSchema,
            [401]: resources_1.ErrorResponseSchema,
            [403]: resources_1.ErrorResponseSchema,
            [404]: null,
            [409]: resources_1.HearingSectionConflictsSchema,
        },
        body: exports.UpdateHearingSectionRequestSchema,
        summary: 'Update a hearing section',
    },
}, {
    strictStatusCodes: true,
    validateResponseOnClient: true,
});
